import { IFileUpload } from '@aca-new/app/shared/components/file-upload/shared/models/interfaces/file-upload.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { IFileResponse } from '@aca-new/app/shared/interfaces/file-response.interface';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { IHttpResponseBody } from '@aca-new/app/shared/models/interfaces/http-response-body.interface';
import { QimaNullableType } from '@aca-new/app/shared/models/types/qima.type';
import { HttpService } from '@aca-new/app/shared/services/http-services/http.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface IOrderAttachment {
  [key: string]: IFileResponse[];
}

@Injectable()
export class SelectAttachmentService {
  public constructor(
    private readonly _storageService: StorageService,
    private readonly _httpService: HttpService
  ) {}

  public getAttachment$(orderId: string, selectedFiles: IFileUpload[]): Observable<IFileResponse[]> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);

    return this._httpService.httpClient
      .get<IHttpResponseBody<QimaNullableType<IOrderAttachment>>>(`${SERVER_URL}/user/${userId}/order/${orderId}/files`, {
        observe: 'response',
      })
      .pipe(
        map((response: Readonly<HttpResponse<IHttpResponseBody<QimaNullableType<IOrderAttachment>>>>): IFileResponse[] => {
          const files: IFileResponse[] = [];
          const fileNames = selectedFiles.map((item: IFileUpload): string => item.name);

          if (response?.body?.content) {
            for (const item in response.body.content) {
              if (item) {
                response.body.content[item].forEach((value: IFileResponse): void => {
                  if (!fileNames.includes(value.fileName)) {
                    files.push(value);
                  }
                });
              }
            }
          }

          return files;
        })
      );
  }

  public copyAttachment$(fileIds: string, newSrcId: string): Observable<void> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);

    return this._httpService.httpClient
      .get<void>(`${SERVER_URL}/user/${userId}/copy-files?fileIds=${encodeURIComponent(fileIds)}&newSrcId=${newSrcId}`, {
        observe: 'body',
      })
      .pipe(map((response: void): void => response));
  }
}
